<div *ngFor="let packageType of packageTypes; let i=index">
  <p>{{'HISTORY.HISTORY_KEYS.name' | translate}} <strong>{{packageType.name}}</strong></p>
  <p>{{'HISTORY.HISTORY_KEYS.value' | translate}} <strong>{{packageType.value}}</strong></p>
  <p>{{'HISTORY.HISTORY_KEYS.unit' | translate}} <strong>{{'HISTORY.HISTORY_KEYS.unit' + packageType.unit | translate}}</strong></p>
  <mat-divider *ngIf="i < packageTypes.length - 1"></mat-divider>
</div>
